'use client';

import React from 'react';

import styles from './AppError.module.css';

interface Props {
  children: React.ReactNode;
}

const AppErrorGlobalContainer = ({ children }: Props) => {
  return <div className={ styles.globalContainer }>{ children }</div>;
};

export default React.memo(AppErrorGlobalContainer);
